class PendingOrderCollection extends App.Collections.BaseCollection {
    url = 'PendingOrder';
    model = App.Models.PendingOrder;
}

App.Collections.PendingOrders = PendingOrderCollection;
